import React, { useEffect } from "react";
import _ from "lodash";
import { Formik } from "formik";
import axios from "axios";
import moment from "moment";
import { Div, Text, Button, Modal, Input, Icon } from "atomize";

import RichTextEditor from "../components/common/RichTextEditor";

import { applyToJoinValidator } from "../validators";
import { setInputs } from "../utilities/helpers";

const BrandApplicationModal = ({ isOpen, onClose, modalContent, ...rest }) => {
  useEffect(() => {
    isOpen && setInputs();
  }, [isOpen]);

  return (
    <Modal
      className="brand-application-modal"
      isOpen={isOpen}
      onClose={onClose}
      rounded="md"
      //maxW="32rem"
      maxW={{ xs: "100vw", md: "30rem" }}
      align={{ xs: "flex-start", md: "center" }}
      m={{ t: { xs: "0", md: "10rem" } }}
      {...rest}
    >
      <Icon
        name="Cross"
        pos="absolute"
        top="1rem"
        right="1rem"
        size="24px"
        onClick={onClose}
        cursor="pointer"
      />
      <Div>
        <Div d="flex">
          <Div
            d="flex"
            align="center"
            w={{ xs: "100vw", lg: "100%" }}
            textColor="black"
          >
            <Div
              d="flex"
              flexDir="column"
              p={{ y: { xs: "4rem", md: "2rem", xl: "1rem" } }}
              justify="space-evenly"
              m="0 auto"
            >
              <Div>
                <RichTextEditor json={modalContent.json} />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
    </Modal>
  );
};

export default BrandApplicationModal;
